var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.user)),_c('span',[_vm._v(_vm._s(_vm.type == "join" ? "已經進入教室" : "已離開教室"))])]),_c('p',[_vm._v(" "+_vm._s(_vm.user)+" "),_c('span',[_vm._v(_vm._s(_vm.type == "join" ? "has entered the classroom." : "has left the classroom."))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }